import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonObject } from "typedjson";
import { DxListToolbarButton } from "./dx-list-toolbar-button";
/** Опции панели инструментов списка. */
let DxListToolbarOptions = class DxListToolbarOptions {
    /** Опции панели инструментов списка. */
    constructor() {
        this._buttons = [];
    }
    get buttons() {
        return this._buttons;
    }
    set buttons(value) {
        this._buttons = value;
    }
};
tslib_1.__decorate([
    jsonArrayMember(DxListToolbarButton, { name: "buttons", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxListToolbarOptions.prototype, "_buttons", void 0);
DxListToolbarOptions = tslib_1.__decorate([
    jsonObject
], DxListToolbarOptions);
export { DxListToolbarOptions };
